import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { AccountContext } from '../../../../components/AccountContext';
import FormContainer from './components/NewTemplateForm';
import { Loading } from '../../../../components/Loading';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { NotificationContext } from '../../../../components/GrowlNotifications';

const SURVEY_TEMP_META = gql`
  query($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      communicationTemplates(first: $first) {
        edges {
          node {
            id
            name
            type
          }
        }
      }
      surveyCompetencies {
        id
        displayName
        abilities {
          id
          displayName
          questionnaireLanguages
          reportLanguages  
        }
      }
    }
  }
`;

const NewSurveyTemplateContainer = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const variables = {
    accountId: currentAccount,
    first: 200,
  };

  return (
    <Query query={SURVEY_TEMP_META} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
          return `Error! ${error.message}`;
        }

        const { account } = data;

        return <FormContainer data={account} />;
      }}
    </Query>
  );
};

export default NewSurveyTemplateContainer;
